import styled from "styled-components";

export const Container = styled.button`
    background-color: rgb(0,0,0,0.1);
    color: ${props => props.theme.colors.primaryText};
    border: none;
    display: flex;
    padding: 1px;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    right: 30px;

    @media (min-width: 576px) {
        display: contents;
        background-color: rgb(0,0,0,0);
    }
`;